import React from "react";
import { Checkbox } from "@mui/material";

const RATE_PRACTICES = [
  {
    key: "Use_A_Nutrient_Balance_Calculator",
    label: "Use a nutrient balance calculator",
    description: "Rates were checked against expected crop removal and available nutrients.",
  },
  {
    key: "Consult_A_CCA_Qualified_Agronomist",
    label: "Consult a CCA qualified agronomist",
    description: "A CCA or equivalent qualified advisor informed the rate decision.",
  },
  {
    key: "Follow_Provincial_Recommendations",
    label: "Follow provincial recommendations",
    description: "Current provincial guidance was used when selecting rates.",
  },
  {
    key: "Use_Variable_Rate_Prescription_Maps",
    label: "Use variable-rate prescription maps",
    description: "A prescription map adjusted rates within the field.",
  },
];

export default function RatesSection({
  fourRAssessment,
  setFourRAssessment,
  onAssessmentChange,
}) {
  const operationsQuestionnaire = fourRAssessment?.operations_questionnaire || {};

  function handleCheck(elementCode, key, value) {
    onAssessmentChange();
    setFourRAssessment((previous) => ({
      ...previous,
      operations_questionnaire: {
        ...(previous.operations_questionnaire || {}),
        [elementCode]: {
          ...(previous.operations_questionnaire?.[elementCode] || {}),
          [key]: value,
        },
      },
    }));
  }

  return (
    <div className="overflow-x-auto border-y border-slate-200">
      <div className="grid min-w-[640px] grid-cols-[minmax(320px,1fr)_120px_120px]">
        <div className="bg-slate-50 px-3 py-2 text-xs font-bold uppercase text-slate-500">
          Decision practice
        </div>
        <div className="bg-slate-50 px-3 py-2 text-center text-xs font-bold uppercase text-slate-500">
          Nitrogen
        </div>
        <div className="bg-slate-50 px-3 py-2 text-center text-xs font-bold uppercase text-slate-500">
          Phosphorus
        </div>
        {RATE_PRACTICES.map((practice) => (
          <React.Fragment key={practice.key}>
            <div className="border-t border-slate-100 px-3 py-2.5">
              <p className="text-sm font-semibold text-slate-800">{practice.label}</p>
              <p className="mt-0.5 text-xs leading-5 text-slate-500">{practice.description}</p>
            </div>
            {["N", "P"].map((elementCode) => (
              <div key={elementCode} className="flex items-center justify-center border-t border-slate-100 px-3 py-2.5">
                <Checkbox
                  onChange={(event) => handleCheck(elementCode, practice.key, event.target.checked)}
                  checked={Boolean(operationsQuestionnaire[elementCode]?.[practice.key])}
                  inputProps={{
                    "aria-label": `${practice.label} for ${elementCode === "N" ? "nitrogen" : "phosphorus"}`,
                  }}
                />
              </div>
            ))}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
